module.exports = __webpack_public_path__ + "static/img/196_TO8_2096.f4bed62.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/196_TO8_2096.jpg
// module id = DNwX
// module chunks = 0